var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 6.304,
    fill: "#00ff40"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.044 9.959c-.218 2.292-1.162 7.856-1.642 10.424-.204 1.087-.604 1.451-.992 1.487-.841.078-1.48-.557-2.296-1.091-1.277-.837-1.998-1.357-3.236-2.174-1.432-.943-.504-1.462.312-2.309.213-.222 3.923-3.597 3.995-3.902.01-.039.018-.182-.067-.257-.085-.075-.21-.05-.3-.029-.128.029-2.167 1.377-6.116 4.043-.58.397-1.103.59-1.573.58-.518-.01-1.514-.292-2.254-.533-.908-.295-1.63-.451-1.567-.953.033-.26.392-.527 1.079-.8 4.227-1.842 7.045-3.056 8.456-3.643 4.027-1.675 4.863-1.966 5.409-1.976.683-.012.848.552.792 1.133Z",
    fill: "#111615"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.80fdd3d462056b6c4c0adf462aaf034a.svg";
export { ForwardRef as ReactComponent };